import { getAxios } from '../utils/requests'
const axios = getAxios()

export default class BankAccountsService {
  static getAccounts (isCreditCard) {
    const params = { isCreditCard }
    return axios.get('/api/financial_resources/bank_accounts', { params })
  }
}
